import { autoinject, bindable, computedFrom } from 'aurelia-framework';
import { ResourceService } from '../../utils/resourceService';
import { TabService } from './tab-service';

@autoinject
export class TabContainer {
	tabViewId: string;
	@bindable tabId: string;
	@bindable titleResource: string;
	@bindable titleResourceParams: any[];

	constructor(
		private tabService: TabService,
		private resourceService: ResourceService) {
	}

	get isActive(): boolean {
		return this.tabService.isActive(this.tabViewId, this.tabId);
	}


	@computedFrom('titleResource', 'titleResourceParams')
	get title(): string {
		return this.titleResource
			? this.resourceService.getResource(this.titleResource, this.titleResourceParams)
			: '';
	}
}
